import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import { Player, Controls } from "@lottiefiles/react-lottie-player";
import "./style.scss";

import { HighlightHTML } from "@learningblocks/storybook-components";

export function FullWidthAnimation(props) {

  const player = useRef();
  const playerWrapper = useRef();
  const playerVisible = useOnScreen(playerWrapper);

  const [playerRun, setPlayerRun] = useState(false);
  const [stopped, setStopped] = useState(true);

  const stop = () => {
    setStopped(true);
  };
  const play = () => {
    setStopped(false);
  }

  useEffect(() => {
    if (playerVisible && player.current && !playerRun) {
      player.current.play();
      setPlayerRun(true)
    }
  }, [playerVisible, playerRun]);

  const animation = (
    <Player
      //alt='content-item'
      //className={props.className}
      loop={(props.loop !== "")?props.loop:true}
      autoplay
      controls
      src={props.animation}
    >
      <Controls visible={true} buttons={['play', 'stop']} />
    </Player>
  );
  return (
    <figure className='fullWidthAnimation' aria-label={props.altText}>
      {animation}
      <figcaption style={{display: (props.caption)?'initial':'none'}}>{props.caption}</figcaption>
    </figure>
  );
  if (props.caption) {
    return (
      <figure className="fullWidthAnimation">
        {animation}
        <figcaption>
          <HighlightHTML
            key={props.id}
            content={props.caption}
            getContentData={props.getGlossaryItem}
            openGlossary={props.onOpenGlossary}
          />
        </figcaption>
      </figure>
    );
  } else {
    return animation;
  }
}

FullWidthAnimation.propTypes = {
  type: PropTypes.string,
  content: PropTypes.array,
  animation: PropTypes.string.isRequired,
  className: PropTypes.string,
  caption: PropTypes.string,
  loop: PropTypes.bool
};


export function useOnScreen(ref) {
  const [isIntersecting, setIntersecting] = useState(false);

  const observer = new IntersectionObserver(
    ([entry]) => setIntersecting(entry.isIntersecting),
    { rootMargin: "-50% 0%" }
  );

  useEffect(() => {
    if (ref.current) {
      observer.observe(ref.current);
      // Remove the observer as soon as the component is unmounted
      return () => {
        observer.disconnect();
      };
    }
  }, [ref.current]);

  return isIntersecting;
}
